var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCaptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505 4830 c-219 -25 -412 -184 -478 -395 l-22 -70 0 -1805 0 -1805 22 -70 c57 -181 204 -322 398 -382 57 -17 149 -18 2135 -18 1986 0 2078 1 2135 18 194 60 341 201 398 382 l22 70 0 1805 0 1805 -22 70 c-56 179 -198 316 -393 381 -53 18 -142 19 -2095 20 -1122 1 -2067 -2 -2100 -6z m1622 -1447 c61 -33 110 -88 130 -147 14 -41 17 -86 18 -221 l0 -170 -212 -3 -213 -2 0 75 0 75 -285 0 -285 0 0 -430 0 -430 285 0 285 0 0 75 0 75 213 -2 212 -3 0 -170 c-1 -135 -4 -180 -18 -221 -20 -59 -69 -114 -130 -147 -42 -22 -42 -22 -562 -22 l-520 0 -55 31 c-72 41 -114 102 -129 187 -17 96 -15 1182 2 1264 21 100 77 164 176 199 28 11 145 13 541 11 502 -2 505 -2 547 -24z m2003 -9 c112 -64 143 -152 138 -394 l-3 -135 -212 -3 -213 -2 0 75 0 75 -285 0 -285 0 0 -430 0 -430 285 0 285 0 0 75 0 75 213 -2 212 -3 3 -135 c5 -242 -26 -330 -138 -394 l-55 -31 -520 0 c-520 0 -520 0 -562 22 -61 33 -110 88 -130 147 -17 47 -18 101 -18 676 0 575 1 629 18 676 26 76 94 139 177 165 14 4 252 7 530 6 l505 -2 55 -31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaptions);
export default __webpack_public_path__ + "static/media/icon-captions.2b29c328020fc37ad1a256fcd4ccb6b8.svg";
export { ForwardRef as ReactComponent };